export default "__VITE_ASSET__cZLvjF0I__"